// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	Button: 'button',
	Button1: 'button-1',
	Button2: 'button-2',
	DataLabelButton: 'data-label-button',
	Empty: 'empty',
	Empty1: 'empty-1',
	Empty2: 'empty-2',
	Empty3: 'empty-3',
	Empty4: 'empty-4',
	Empty5: 'empty-5',
	Empty6: 'empty-6',
	Empty7: 'empty-7',
	AddUploadButton: 'add-upload-button',
	Search: 'search',
	Category: 'category',
	ToggleCategoryButton: 'toggle-category-button',
	ToggleSortByUsageWeightDiv: 'toggle-sort-by-usage-weight-div',
	Button3: 'button-3',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
